import {ADD_TABLE,CLEAR_TABLE} from "./types"

export const AddTable = (item) => ({
  type: ADD_TABLE,
  payload: item,
});

export const clearTable = () => ({
  type: CLEAR_TABLE,
});